export interface MatrixConfig {
    horizontal: string[];
    vertical: string[];
    values: string[][];
}

export class Matrix {
    horizontal: string[];
    vertical: string[];
    values: string[][];

    constructor(config: MatrixConfig) {
        this.validateConfig(config);
        this.horizontal = config.horizontal;
        this.vertical = config.vertical;
        this.values = config.values;
    }

    getValue(horizontal: string, vertical: string): string | undefined {
        const hIndex = this.horizontal.findIndex(
            (value) => value === horizontal,
        );
        const vIndex = this.vertical.findIndex((value) => value === vertical);
        return this.values[vIndex]?.[hIndex];
    }

    toJSON(): MatrixConfig {
        return {
            horizontal: [...this.horizontal],
            vertical: [...this.vertical],
            values: [...this.values],
        };
    }

    private validateConfig(config: MatrixConfig): void {
        if (config.vertical.length !== config.values.length) {
            throw new Error(
                `Vertical length must match values length, got ${config.vertical.length.toString()} and ${config.values.length.toString()}`,
            );
        }
        for (const row of config.values) {
            if (row.length !== config.horizontal.length) {
                throw new Error(
                    `Values rows must match horizontal length, got ${row.length.toString()} and ${config.horizontal.length.toString()}`,
                );
            }
        }
    }
}
